import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { fileTypes } from '../features/BillsHub/components/PreviewAddAttachment/types';

export const useGetBillHubAttachmentData = ({
  customerId, accountExternalId, documentId,
}: { customerId: string, accountExternalId: string, documentId: string }) => useMutation(
  async () => {
    try {
      const { data, headers } = await httpService({
        url: `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/document/${documentId}/download`,
        method: 'get',
        responseType: 'blob',
      });
      return {
        url: URL.createObjectURL(data),
        type: headers['content-type'].includes('pdf') ? fileTypes.PDF : fileTypes.IMAGE,
      };
    } catch (e) {
      return undefined;
    }
  },
);
